import { MoreVerticalOutlineIcon } from '@carboncopyco/icons';
import { Dropdown } from '@carboncopyco/ui';
import type { ReactNode } from 'react';

type ColumnOptionsProps = {
  isOpen: boolean;
  children: ReactNode;
  onOpenChange: (isOpen: boolean) => void;
};

export const ColumnOptions = ({
  isOpen,
  children,
  onOpenChange,
}: ColumnOptionsProps) => (
  <Dropdown
    zIndex={10}
    interactive
    align="start"
    open={isOpen}
    onOpenChange={onOpenChange}
    triggerElement={
      <div className="text-ds-primary">
        <MoreVerticalOutlineIcon size={16} />
      </div>
    }
    triggerElementAriaLabel="Column options trigger"
  >
    {children}
  </Dropdown>
);
